import React, { useRef, useState } from "react";
// import { Link } from 'react-router-dom'
// import AddIcon from '@mui/icons-material/Add';
import Modal from 'react-modal';
import CloseIcon from '@mui/icons-material/Close';
// import { Tab, Tabs, TabList, TabPanel } from 'react-tabs';
import { useGlobalContext } from "../../../Context/GlobalContext";
import Select from 'react-select';
import Cookies from "js-cookie";

const PastEmploymentDetail = () => {

    const { baseUrl, selectedStaff, openToast } = useGlobalContext();
    const [pastEmploymentID, setPastEmploymentID] = useState(selectedStaff?.staffDetails?.past_Employment?.id);
    const [isLoading, setIsLoading] = useState(false);

    const [editPastEmployment, setEditPastEmployment] = useState(!!selectedStaff?.staffDetails?.past_Employment);
    const [pastEmploymentStatus, setPastEmploymentStatus] = useState(selectedStaff?.staffDetails?.past_Employment?.past_Employment_status);
    const [pastEmployment, setPastEmployment] = useState({
        companyName: selectedStaff?.staffDetails?.past_Employment?.company_name,
        designation: selectedStaff?.staffDetails?.past_Employment?.designation,
        joiningDate: selectedStaff?.staffDetails?.past_Employment?.joining_date,
        leavingDate: selectedStaff?.staffDetails?.past_Employment?.leaving_date,
        currency: selectedStaff?.staffDetails?.past_Employment?.currency,
        salary: selectedStaff?.staffDetails?.past_Employment?.salary,
        companyGst: selectedStaff?.staffDetails?.past_Employment?.company_gst,
    });





    console.log(pastEmployment);


    async function addPastEmployment() {
        setIsLoading(true);
        try {
            const response = await fetch(baseUrl + "/past-employment", {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                    "Authorization": `Bearer ${Cookies.get("flowChangerAuthToken")}`

                },
                body: JSON.stringify({
                    staffId: selectedStaff?.staffDetails?.id,
                    ...pastEmployment,
                    salary: parseFloat(pastEmployment?.salary),
                    company_name: pastEmployment?.companyName,
                    company_gst: pastEmployment?.companyGst,
                    leaving_date: new Date(pastEmployment?.leavingDate).toISOString(),
                    joining_date: new Date(pastEmployment?.joiningDate).toISOString(),
                    currency: pastEmployment?.currency?.value
                })
            });
            console.log(response);
            if (response.status === 201) {
                const result = await response.json();
                console.log(result);
                setPastEmployment({
                    companyName: result?.company_name,
                    designation: result?.designation,
                    joiningDate: result?.joining_date,
                    leavingDate: result?.leaving_date,
                    currency: result?.currency,
                    salary: result?.salary,
                    companyGst: result?.company_gst
                })
                setPastEmploymentStatus(result?.past_Employment_status);
                openToast("Past Employment successfully added", "success");
                setEditPastEmployment(true);
                setPastEmploymentID(result?.id);
            } else {
                openToast("An error occurred while adding past employment", "error");
            }
        } catch (error) {
            console.error("Error adding past employment:", error);
            openToast("An error occurred while adding past employment", "error");
        }
        finally {
            setIsLoading(false);
            closeModal2();
        }
    }
    async function editingPastEmployment() {
        setIsLoading(true);
        try {
            const response = await fetch(baseUrl + "/past-employment/" + selectedStaff?.staffDetails?.id, {
                method: "PUT",
                headers: {
                    "Content-Type": "application/json",
                    "Authorization": `Bearer ${Cookies.get("flowChangerAuthToken")}`

                },
                body: JSON.stringify({
                    ...pastEmployment,
                    salary: parseFloat(pastEmployment?.salary),
                    company_name: pastEmployment?.companyName,
                    company_gst: pastEmployment?.companyGst,
                    leaving_date: new Date(pastEmployment?.leavingDate).toISOString(),
                    joining_date: new Date(pastEmployment?.joiningDate).toISOString(),
                    currency: pastEmployment?.currency?.value
                })
            });
            console.log(response);
            if (response.status === 200) {
                const result = await response.json();
                console.log(result);
                // setPastEmployment({
                //     companyName: result?.company_name,
                //     designation: result?.designation,
                //     joiningDate: result?.joining_date,
                //     leavingDate: result?.leaving_date,
                //     currency: result?.currency,
                //     salary: result?.salary,
                //     companyGst: result?.company_gst
                // })
                openToast("Past Employment successfully updated", "success");
            } else {
                openToast("An error occurred while updating past employment", "error");
            }
        } catch (error) {
            console.error("Error updating past employment:", error);
            openToast("An error occurred while updating past employment", "error");
        }
        finally {
            setIsLoading(false);
            closeModal2();
        }
    }
    async function deletedPastEmployment() {
        try {
            const response = await fetch(baseUrl + "/past-employment/" + pastEmploymentID, {
                method: "DELETE",
                headers: {
                    "Content-Type": "application/json",
                    "Authorization": `Bearer ${Cookies.get("flowChangerAuthToken")}`

                },

            });
            console.log(response);
            if (response.status === 200) {
                const result = await response.json();
                openToast("Past Employment successfully deleted", "success");
                setEditPastEmployment(false);
                closeModal2();
            } else {
                openToast("An error occurred while deleting past employment", "error");
            }
        } catch (error) {
            console.error("Error deleting past employment:", error);
            openToast("An error occurred while deleting past employment", "error");
        }
    }


    let subtitle;

    const [modalIsOpen2, setIsOpen2] = React.useState(false);
    function openModal2() {
        setIsOpen2(true);
    }

    const currencyOptions = [
        { value: 'INR', label: 'INR' },
        { value: 'USD', label: 'USD' },
        { value: 'EUR', label: 'EUR' },
        { value: 'GBP', label: 'GBP' },
    ];

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setPastEmployment({ ...pastEmployment, [name]: value });
    };

    const handleCurrencyChange = (selectedOption) => {
        setPastEmployment({ ...pastEmployment, currency: selectedOption });
    };


    function afterOpenModal2() {
        // references are now sync'd and can be accessed.
        subtitle.style.color = '#000';

    }

    function closeModal2() {
        setIsOpen2(false);
    }


    const handleSubmit = (e) => {
        e.preventDefault();
        addPastEmployment();
    };

    return (
        <>
            <div className='relative flex flex-col xl:pt-[30px] w-full'>
                <div className='top-0 bg-white pt-[10px] pr-0 xl:pr-[0px] pb-[10px] pl-[0] w-[100%]'>
                    <h3 className='font-medium'>Past Employment Detail</h3>
                </div>

                <div className='flex justify-between items-center border-1 bg-[#fff] shadow-cs mb-3 p-4 border rounded-lg' >
                    <h4 className='font-light'>Past Employment</h4>
                    <p className='font-light'></p>
                    <button className='second-btn' onClick={openModal2}  >
                        {editPastEmployment ? "Edit" : "Add"}
                    </button>

                </div>


                <div className='flex justify-between items-center border-1 bg-[#fff] shadow-cs mb-3 p-4 border rounded-lg' >
                    <h4 className='font-light'>Verification Status
                    </h4>
                    <p className='font-light'>{pastEmploymentStatus}</p>
                </div>



                <Modal
                    isOpen={modalIsOpen2}
                    onAfterOpen={afterOpenModal2}
                    onRequestClose={closeModal2}
                    // style={customStyles}
                    contentLabel="Example Modal"
                    className="top-[50%] bottom-auto left-[50%] absolute bg-[#fff] shadow-cs px-3 rounded-[10px] w-[96%] xl:w-[35%] xl:h-[60%] translate-x-[-50%] translate-y-[-50%]"

                >

                    <h2 ref={(_subtitle) => (subtitle = _subtitle)} className='p-3 border-b-1 text-[13px] xl:text-[15px]'>Add Past Employment</h2>
                    <button onClick={closeModal2} className='top-[3px] right-[5px] absolute bg-[#27004a] rounded-full font-semibold'><CloseIcon className='text-white' /></button>
                    <div className='p-2 border-t h-[300px] overflow-y-scroll'>
                        <div className="">
                            <label htmlFor="companyName" className="font-medium text-[13px] xl:text-[14px]">
                                Company Name<span className="text-red-500">*</span>
                            </label>
                            <input
                                type="text"
                                id="companyName"
                                name="companyName"
                                required
                                className="border-1 mt-1 newsetup3 mb-[10px] p-[5px] border rounded-md w-[100%] placeholder:font-font-normal text-[#000] text-[14px] focus:outline-none"
                                value={pastEmployment.companyName}
                                onChange={handleInputChange}
                            />
                        </div>
                        <div className="">
                            <label htmlFor="designation" className="font-medium text-[13px] xl:text-[14px]">
                                Designation
                            </label>
                            <input
                                type="text"
                                id="designation"
                                name="designation"
                                className="border-1 mt-1 mb-[10px] newsetup3 p-[5px] border rounded-md w-[100%] placeholder:font-font-normal text-[#000] text-[14px] focus:outline-none"
                                value={pastEmployment.designation}
                                onChange={handleInputChange}
                            />
                        </div>
                        <div className="">
                            <div>
                                <label htmlFor="joiningDate" className="font-medium text-[13px] xl:text-[14px]">
                                    Joining Date<span className="text-red-500">*</span>
                                </label>
                                <input
                                    type="date"
                                    id="joiningDate"
                                    name="joiningDate"
                                    required
                                    className="border-1 bg-white mt-1 newsetup3 mb-[10px] p-[5px] border rounded-md w-[100%] placeholder:font-font-normal text-[#000] text-[14px] focus:outline-none"
                                    value={pastEmployment?.joiningDate?.split('T')[0]}
                                    onChange={handleInputChange}
                                />
                            </div>
                            <div>
                                <label htmlFor="leavingDate" className="font-medium text-[13px] xl:text-[14px]">
                                    Leaving Date<span className="text-red-500">*</span>
                                </label>
                                <input
                                    type="date"
                                    id="leavingDate"
                                    name="leavingDate"
                                    required
                                    className="border-1 bg-white newsetup3 mt-1 mb-[10px] p-[5px] border rounded-md w-[100%] placeholder:font-font-normal text-[#000] text-[14px] focus:outline-none"
                                    value={pastEmployment?.leavingDate?.split('T')[0]}
                                    onChange={handleInputChange}
                                />
                            </div>
                        </div>
                        <div className=" ">
                            <div>
                                <label htmlFor="currency" className="font-medium text-[13px] xl:text-[14px]">
                                    Currency
                                </label>
                                <Select
                                    id="currency"
                                    name="currency"
                                    options={currencyOptions}
                                    value={currencyOptions.filter(option => option.value === pastEmployment?.currency)}
                                    onChange={(selectedOption) => {
                                        handleCurrencyChange(selectedOption.value);
                                    }}
                                    className="bg-white mt-1 mb-[10px] p-[0px] rounded-md w-[100%] placeholder:font-font-normal text-[#000] text-[14px] react-select-container focus:outline-none"
                                    classNamePrefix="react-select"
                                />
                            </div>
                            <div>
                                <label htmlFor="salary" className="font-medium text-[13px] xl:text-[14px]">
                                    Salary
                                </label>
                                <input
                                    type="number"
                                    id="salary"
                                    name="salary"
                                    className="border-1 bg-white newsetup3 mt-1 mb-[10px] p-[5px] border rounded-md w-[100%] placeholder:font-font-normal text-[#000] text-[14px] focus:outline-none"
                                    value={pastEmployment.salary}
                                    onChange={handleInputChange}
                                />
                            </div>
                        </div>
                        <div className="">
                            <label htmlFor="companyGst" className="font-medium text-[13px] xl:text-[14px]">
                                Company GST
                            </label>
                            <input
                                type="text"
                                id="companyGst"
                                name="companyGst"
                                className="border-1 bg-white mt-1 newsetup3 mb-[10px] p-[5px] border rounded-md w-[100%] placeholder:font-font-normal text-[#000] text-[14px] focus:outline-none"
                                value={pastEmployment.companyGst}
                                onChange={handleInputChange}
                            />
                        </div>

                    </div>
                    {
                        editPastEmployment ?
                            (<div className='flex justify-end gap-[10px] pt-3 pr-[10px] pb-3 border-t'>
                                <button className='first-btn' onClick={() => {
                                    deletedPastEmployment()
                                }}>Delete</button>
                                <button disabled={isLoading} className={'second-btn ' + (isLoading && "cursor-not-allowed opacity-50")} onClick={() => {
                                    editingPastEmployment()
                                }}>Edit </button>

                            </div>) : (<div className='flex justify-end gap-[10px] pt-3 pr-[10px] pb-3 border-t'>
                                <button className='first-btn' onClick={closeModal2}>Cancel</button>
                                <button disabled={isLoading} className={'second-btn ' + (isLoading && "cursor-not-allowed opacity-50")} onClick={handleSubmit}>Save </button>
                            </div>)
                    }
                </Modal>

            </div>
        </>
    )
}

export default PastEmploymentDetail